import React from 'react';
import { FormControl, InputAdornment, InputLabel, OutlinedInput } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useTranslate } from 'ra-core';


export default function FilterTextField(props) {
    const { filterText, setFilterText } = props;
    const translate = useTranslate();
    return (
        <FormControl fullWidth variant="outlined">
            <InputLabel>{translate(`cmss.resources.file-explorer.search`)}</InputLabel>
            <OutlinedInput
                endAdornment={<InputAdornment position="end"><SearchIcon/></InputAdornment>}
                labelWidth={60}
                value={filterText}
                onChange={ (event) => setFilterText(event.target.value) }
            />
        </FormControl>
    )
}